import type {TaskWithInstance} from '@backend/types'
import {isAgendaTask} from './agenda'

export function getDefaultTaskRoute(tasks: TaskWithInstance[]): string {
  if (tasks.some((task) => isAgendaTask(task))) {
    return '/agenda'
  }

  const hasInbox = tasks.some((task) => task.folder === 'inbox' && task.instances.some((instance) => !instance.done))
  if (hasInbox) {
    return '/inbox'
  }

  return '/next'
}
